/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";

import { formatDate } from "../../../helpers/date";
import { cleanHTMLString } from "../../../utils";

import NumberCell from "../../tableFields/NumberCell";
import NumberCellNegative from "../../tableFields/NumberCellNegative";

export const CONTRACTS_BY_TYPE_COLUMNS = [
  {
    Header: "Dept.",
    accessor: "department",
    id: "department",
    Cell: ({ value }) => value || "--",
    minWidth: 90
  },
  {
    Header: "Project Manager",
    id: "projectManager",
    accessor: "projectManager",
    Cell: ({ value }) => value || "--",
    minWidth: 120
  },
  {
    Header: "Customer",
    accessor: "customer",
    id: "customer",
    Cell: ({ value }) => value || "--",
    minWidth: 250
  },
  {
    Header: "Project Name",
    accessor: "name",
    id: "name",
    Cell: ({ value }) => value || "--",
    minWidth: 250
  },
  {
    Header: "Due Date",
    accessor: "due_date",
    id: "due_date",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--"),
    minWidth: 100
  },
  {
    Header: "Category",
    accessor: "category",
    id: "category",
    Cell: ({ value }) => value || "--",
    minWidth: 100
  },
  {
    Header: "Department Category",
    accessor: "departmentCategory",
    id: "departmentCategory",
    Cell: ({ value }) => value || "--",
    minWidth: 100
  },
  {
    Header: "Status",
    accessor: "status",
    id: "status",
    Cell: ({ value }) => value || "--",
    minWidth: 100
  },
  {
    Header: "Project Type",
    accessor: "project_type",
    id: "project_type",
    Cell: ({ value }) => value || "--",
    minWidth: 120
  },
  {
    Header: "Primary Resource",
    accessor: "resource1",
    id: "resource1",
    Cell: ({ value }) => value || "--",
    minWidth: 120
  },
  {
    Header: "Secondary Resource",
    accessor: "resource2",
    id: "resource2",
    Cell: ({ value }) => value || "--",
    minWidth: 120
  },
  {
    Header: "Sales Person",
    accessor: "salesperson",
    id: "salesperson",
    Cell: ({ value }) => value || "--",
    minWidth: 120
  },
  {
    Header: "Budget Amount",
    accessor: "budgetAmount",
    id: "budgetAmount",
    Cell: ({ value }) => <NumberCell value={`$${value || 0}`} />,
    minWidth: 120
  },
  {
    Header: "Budget Hours",
    accessor: "budgetHours",
    id: "budgetHours",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    minWidth: 100
  },
  {
    Header: "Billed Hours",
    accessor: "billableHours",
    id: "billableHours",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    minWidth: 100
  },
  {
    Header: "Balance Avail",
    accessor: "balance",
    id: "balance",
    Cell: ({ value }) => (
      <NumberCellNegative
        getValue={(val) => Number(val)?.toFixed(2) || 0}
        value={value}
      />
    ),
    minWidth: 120
  },
  {
    Header: "Balance Rem %",
    accessor: "balanceRem",
    id: "balanceRem",
    Cell: ({ value }) => (
      <NumberCellNegative
        getValue={(val) => Number(val)?.toFixed(2) || 0}
        value={value}
      />
    ),
    minWidth: 120
  },
  {
    Header: "Total Actual Hours",
    accessor: "actualHours",
    id: "actualHours",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    minWidth: 100
  },
  {
    Header: "Billing Rate",
    accessor: "rate",
    id: "rate",
    Cell: ({ value }) => <NumberCell value={`$${value || 0}`} />,
    minWidth: 100
  },
  {
    Header: "Yield",
    accessor: "yield",
    id: "yield",
    Cell: ({ value }) => <NumberCell value={`$${value || 0}`} />,
    minWidth: 120
  },
  {
    Header: "Notes",
    accessor: "notes",
    id: "notes",
    Cell: ({ value }) =>
      value?.note ? (
        <div style={{ whiteSpace: "pre-wrap" }}>
          {value.date} - {cleanHTMLString(value.note)}
        </div>
      ) : (
        "--"
      ),
    minWidth: 250
  }
];
